import _ from 'lodash'
import storage from "../plugins/storage";
import {Message} from 'element-ui'

export default function configInterceptor (axios) {
  axios.interceptors.request.use(config => {
    config.headers = Object.assign(config.headers, {
      deviceType:'web'
    })

    if (config.method === 'get') {
      config.params = {
        ...config.params
      }
    }
    const prefix = localStorage.getItem('userRole')
    // 有一些是固定的url
    if (config.url.indexOf('{prefix}') > -1) {
      config.url = config.url.replace('{prefix}', prefix)
    }

    const token = storage.get('token')
    if (token) {
      config.headers = Object.assign(config.headers, {
        'school_token':token
      })
    }
    return config
  }, err => {
    return Promise.reject(err)
  })

  axios.interceptors.response.use(
    (response) => {
      if (_.isPlainObject(response.data)) {
        if (response.data.isSuccess) {
          return response.data
        } else {
          Message.error(response.data.resultMsg || "服务失败，请稍候重试")
          return Promise.reject(Error(response.data.resultMsg || '服务器错误，请稍后重试'))
        }
      } else {
        return response.data
      }
    },
    (error) => {
      if (error.response) {
        if (error.response.status === 401) {
          local.href= location.origin+'/#/service-center-login'
        } else if (error.response.status !== 404) {
          Message.error(error.response.data.resultMsg || "服务失败，请稍候重试")
        }
      }
      return Promise.reject(error)
    }
  )
}
